import { zodResolver } from '@hookform/resolvers/zod'
import Typography from '@repo/ui/typography'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import {
  MedicalAttestationTypeEnum,
  MedicalAttestationTypeEnumMapping
} from '../../../../lib/types/enums/medical-attestation-sending/medical-attestation-sending.enum'
import { ValidateMedicalAttestationInput } from '../../../../lib/types/models/medical-attestation-sending/medical-attestation-sending'
import { BaseFormProps } from '../../../../lib/types/utils'
import { getSubmitAction } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { createEnumSchema } from '../../../../lib/utils/validations/enum-validation'
import { createStringSchema } from '../../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledInput from '../../../elements/inputs/controlled-input'
import ControlledRadioInput from '../../../elements/inputs/controlled-radio-input'
import ValidationButtons from '../../../elements/validation-buttons'

const formSchema: ZodType<ValidateMedicalAttestationInput> = z.object({
  type: createEnumSchema({
    fieldName: "Type d'attestation",
    enumType: MedicalAttestationTypeEnum
  }),
  content: createStringSchema('Contenu', { nullish: true })
})

const ValidateMedicalStatementForm = ({
  defaultValues,
  ...validationButtonProps
}: BaseFormProps<ValidateMedicalAttestationInput>) => {
  const form = useForm<ValidateMedicalAttestationInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className="flex flex-col gap-4 p-3">
          <div>
            <Typography variant={'label-semibold'}>Type d'attestation :</Typography>
            <div className={'h-1'} />
            <div className={'flex gap-10'}>
              {Object.values(MedicalAttestationTypeEnum).map((type) => (
                <FormField
                  key={type}
                  control={form.control}
                  name={'type'}
                  render={({ field }) => (
                    <FormItem>
                      <FormControl>
                        <ControlledRadioInput
                          {...field}
                          label={MedicalAttestationTypeEnumMapping[type]}
                          checked={field.value === type}
                          onCheck={() => field.onChange(type)}
                        />
                      </FormControl>
                    </FormItem>
                  )}
                />
              ))}
            </div>
          </div>

          <FormField
            control={form.control}
            name="content"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <ControlledInput
                    {...field}
                    type="textarea"
                    label="Information complémentaire éventuelle"
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default ValidateMedicalStatementForm
